import { theme, toRem } from '../../styles';
import styled from 'styled-components';

export const StyledRateCard = styled.section`
  background-color: ${theme.colors.white};
  .top-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: ${toRem(8)};
    .available-room-label {
      display: none;
    }
    .full-price-input {
      input[type='checkbox'] {
        & + label {
          font-size: ${toRem(14)};
          line-height: ${toRem(20)};
          font-weight: 700;
        }
      }
    }
  }
  .selected-room {
    font-size: ${toRem(22)};
    line-height: ${toRem(26)};
    font-weight: 700;
    margin-bottom: ${toRem(16)};
  }
  .rate-card-container {
    display: flex;
    flex-direction: column;
    border-radius: ${toRem(14)};
    box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
    margin-bottom: ${toRem(24)};
  }
  .card-wrapper {
    display: flex;
    flex-direction: column;
  }
  .divider {
    border-bottom: 1px solid ${theme.colors['close-silver']};
  }
  .image-container {
    position: relative;
    cursor: pointer;
    .sold-out-label {
      background-color: ${theme.colors.white};
      position: absolute;
      top: ${toRem(16)};
      left: ${toRem(16)};
      border-radius: ${toRem(4)};
      font-size: ${toRem(12)};
      line-height: ${toRem(16)};
      padding: ${toRem(5)} ${toRem(8)};
      font-weight: 700;
    }
  }
  .room-desc {
    padding: ${toRem(24)} ${toRem(24)} ${toRem(24)};
    border-bottom: ${toRem(1)} solid ${theme.colors['light-gray-3']};
  }
  .exact-label,
  .other-label,
  .room-name,
  .room-rate {
    font-size: ${toRem(22)};
    line-height: ${toRem(26)};
    font-weight: 700;
  }
  .redemption-room-rate {
    color: ${theme.colors['merch-green']};
  }
  .rate-details {
    margin: ${toRem(24)} ${toRem(24)} 0;
    padding-bottom: ${toRem(24)};
    border-bottom: ${toRem(1)} solid ${theme.colors['light-gray-3']};
    .rate-content-container {
      display: flex;
      justify-content: space-between;
    }

    .rate-display {
      display: flex;
      flex-direction: column;
    }

    .rate-name {
      font-size: ${toRem(16)};
      line-height: ${toRem(22)};
      font-weight: 700;
    }
    .currency-label {
      font-size: ${toRem(12)};
      line-height: ${toRem(16)};
    }

    .amount-display {
      &:dir(rtl) {
        display: flex;
        align-items: baseline;
        float: right;
        flex-direction: row;
      }
    }
    .per-room-label {
      font-size: ${toRem(12)};
      line-height: ${toRem(18)};
    }
    .taxes-label {
      font-size: ${toRem(12)};
      line-height: ${toRem(18)};
      color: ${theme.colors['light-gray-10']};
    }
    .icon-information {
      font-size: ${toRem(14)};
      line-height: ${toRem(20)};
    }
    .member-icon {
      color: ${theme.colors.carrot};
    }
    .rate-description {
      font-size: ${toRem(12)};
      line-height: ${toRem(18)};
      color: ${theme.colors['light-gray-10']};
      font-weight: ${theme.fonts['fontWeightRegular']};
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .rate-description:first-letter {
      text-transform: uppercase;
    }
    .old-price {
      font-size: ${toRem(12)};
      line-height: ${toRem(14)};
      font-weight: ${theme.fonts['fontWeightMedium']};
      color: ${theme.colors['light-gray-10']};
    }
    .hide-component {
      visibility: hidden;
    }
    &.no-border {
      border-bottom: 0;
    }
  }
  .room-detail-link {
    padding-right: ${toRem(8)};
    font-size: ${toRem(12)};
    line-height: ${toRem(18)};
    font-family: ${theme.fontFamily.swiss};
    color: ${theme.colors['light-gray-10']};
    font-weight: ${theme.fonts['fontWeightRegular']};
    border-bottom: ${toRem(1)} solid ${theme.colors['light-gray-10']};
  }
  .t-capitalize {
    text-transform: capitalize;
  }
  .button-with-was-price {
    padding-top: ${toRem(18)};
  }
  .button-select,
  .rate-button {
    font-size: 0.8125rem;
    height: ${toRem(32)};
    padding: 0 ${toRem(32)};
    line-height: ${toRem(17)};
    border-radius: ${toRem(22)};
  }
  .more-packages {
    font-size: ${toRem(16)};
    line-height: ${toRem(22)};
    font-weight: 700;
  }
  .MuiAccordionSummary-root {
    padding: 0;
    margin: 0 ${toRem(24)};
    border-top: 1px solid;
  }
  .MuiAccordionDetails-root {
    flex-direction: column;
    padding: 0;
  }
  .MuiAccordionSummary-content {
    margin: ${toRem(27)} 0;
  }
  .soc-wrapper-mobile {
    padding: ${toRem(24)} 0 ${toRem(24)} 0;
    margin: 0 ${toRem(24)} 0 ${toRem(24)};
    border-top: 1px solid;
  }
  .button-container {
    margin: 48px auto;
    text-align: center;
  }
  .view-more-button {
    height: 52px;
    width: 365px;
    @media ${theme.mediaQuery.allMobiles} {
      width: 333px;
    }
  }
  .group-alert {
    padding: ${toRem(24)} 0 0;
    display: flex;
    .icon-alert {
      position: relative;
      top: ${toRem(-3)};
    }
    .label {
      font-size: ${toRem(14)};
      line-height: ${toRem(20)};
    }
    &:last-child {
      padding: ${toRem(18)} ${toRem(24)} ${toRem(24)};
    }
  }
  .rate-content {
    width: ${toRem(176)};
  }

  .tax-and-currency {
    width: 100%;
  }

  @media ${theme.mediaQuery.tablet} {
    .top-container {
      padding-bottom: ${toRem(16)};
      .available-room-label {
        font-size: ${toRem(14)};
        line-height: ${toRem(16)};
        display: block;
      }
    }
    .card-wrapper {
      flex-direction: row;
    }
    .room-rate-wrapper {
      flex-grow: 1;
    }
    .room-desc {
      display: flex;
      justify-content: space-between;
      padding: ${toRem(16)} ${toRem(24)};
      margin-bottom: ${toRem(24)};
    }
    .rate-details {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      border-bottom: 0;
      margin-top: 0;
      .rate-content-container {
        border-bottom: 0;
      }
      padding: ${toRem(24)} 0 0;
    }
    .room-name {
      max-width: ${toRem(337)};
    }
    .rate-name {
      max-width: ${toRem(210)};
    }
    .rate-content {
      width: ${toRem(134)};
    }
    .rate-info-block {
      width: ${toRem(194)};
    }
    .rate-info-margin {
      margin-top: ${toRem(18)};
    }
    .details-with-old-price {
      padding-top: ${toRem(6)} !important;
    }
    .group-alert {
      padding: ${toRem(42)} ${toRem(24)} 0;
      .icon-alert {
        top: 0;
      }
      &:last-child {
        padding: ${toRem(18)} ${toRem(24)} ${toRem(24)};
      }
    }
    .tax-and-currency {
      width: auto;
    }
  }
  @media ${theme.mediaQuery.desktop} {
    .rate-content {
      width: ${toRem(84)};
    }
    .rate-info-block {
      width: ${toRem(137)};
    }
  }
  @media ${theme.mediaQuery.largeDesktop} {
    .room-name {
      max-width: ${toRem(397)};
    }
    .rate-details {
      padding: ${toRem(48)} 0 0;
      justify-content: flex-start;
    }
    .rate-info-block {
      width: ${toRem(212)};
    }
    .rate-content {
      width: ${toRem(176)};
    }
    .details-with-old-price {
      padding-top: ${toRem(30)} !important;
    }
  }
`;

export const StyledComp = styled.div`
  height: 30vh;
`;

export const StyledLoader = styled.div`
  background-color: ${theme.colors.white};

  .room-container {
    display: grid;
    border-radius: 14px;
    box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
    @media ${theme.mediaQuery.tablet} {
      grid-template-columns: auto 1fr;
    }
  }

  .skeleton-container {
    display: grid;
    grid-template-columns: 1fr ${toRem(60)};
    grid-gap: ${toRem(8)};
  }

  .room-name {
    align-items: center;
    border-bottom: 1px solid ${theme.colors['close-silver']};
  }

  .rate-name-price {
    display: grid;
    grid-gap: ${toRem(8)};
    @media ${theme.mediaQuery.tablet} {
      grid-template-columns: 1fr 1fr;
    }
  }
`;
